<template>
    <div>
        <div class="alert alert-success" v-if="sent">
            {{ __('Thank you for your information request.') }}
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="order_by" id="genderMale" value="male" v-model="data.gender">
                        <label class="form-check-label" for="genderMale">{{ __('Male') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="order_by" id="genderFemale" value="female" v-model="data.gender">
                        <label class="form-check-label" for="genderFemale">{{ __('Female') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="order_by" id="genderOther" value="other" v-model="data.gender">
                        <label class="form-check-label" for="genderOther">{{ __('Other') }}</label>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label class="form-label">{{ __('First name') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('first_name') }" v-model="data.first_name">
                    <div class="invalid-feedback" v-if="hasError('first_name')">
                        <span v-for="error in errors.first_name">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">{{ __('Last name') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('last_name') }"  v-model="data.last_name">
                    <div class="invalid-feedback" v-if="hasError('last_name')">
                        <span v-for="error in errors.last_name">{{ error }}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label class="form-label">{{ __('Organisation') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('organisation') }" v-model="data.organisation">
                    <div class="invalid-feedback" v-if="hasError('organisation')">
                        <span v-for="error in errors.organisation">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">{{ __('Website') }}</label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('website') }" v-model="data.website">
                    <div class="invalid-feedback" v-if="hasError('website')">
                        <span v-for="error in errors.website">{{ error }}</span>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <label class="form-label">{{ __('Email address') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('email') }" v-model="data.email">
                    <div class="invalid-feedback" v-if="hasError('email')">
                        <span v-for="error in errors.email">{{ error }}</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">{{ __('Phone') }}<sup>*</sup></label>
                    <input type="text" class="form-control" :class="{ 'is-invalid' : hasError('phone') }" v-model="data.phone">
                    <div class="invalid-feedback" v-if="hasError('phone')">
                        <span v-for="error in errors.phone">{{ error }}</span>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label class="form-label">{{ __('Please fill in your questions and/or comments here') }}</label>
                <textarea class="form-control" rows="5" v-model="data.comments"></textarea>
            </div>
            <div class="mb-3">
                <recaptcha :language="language" ref="recaptcha" :sitekey="siteKey" v-if="siteKey" @verify="captchaVerified"></recaptcha>
                <div class="invalid-feedback d-block" v-if="hasError('recaptcha')">
                    <span v-for="error in errors.recaptcha">{{ error }}</span>
                </div>
            </div>
            <button class="btn btn-lg btn-primary text-white" :class="{ disabled : sending }" @click="send"><i class="fa fa-spin fa-circle-notch" v-if="sending"></i> {{ __('Send') }} <i class="fa fa-chevron-right"></i></button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['locale'],
        data() {
            return {
                sent : false,
                sending: false,
                errors: null,
                siteKey : null,
                language : null,
                data : {
                    gender : 'male',
                    first_name : null,
                    last_name : null,
                    organisation : null,
                    website : null,
                    email : null,
                    phone : null,
                    comments : null,
                    recaptcha : null,
                }
            }
        },
        methods: {
            send() {
                if (this.sending) {
                    return;
                }

                this.sending = true;
                axios.post('/'+ this.locale +'/information-requests', this.data)
                     .then(response => {
                         this.sending = false;
                         this.sent = true;
                         this.errors = null;
                     }).catch(error => {
                         if (error.response.data && error.response.data.errors) {
                             this.errors = error.response.data.errors;
                         }
                         this.sending = false;
                         this.$refs.recaptcha.reset() // Direct call reset method
                })
            },
            hasError(field) {
                return this.errors && this.errors[field] && this.errors[field].length > 0;
            },
            captchaVerified(token) {
                this.data.recaptcha = token;
            }
        },
        mounted() {
            this.language = window._locale;
            this.siteKey = window.google_site_key;
        },
    }
</script>
